/**
 * @var string Unloading со статусом "Запланирована"
 */
export const UNLOADING_PLANNED = 'planned';
/**
 * @var string Unloading со статусом "Завершена"
 */
export const UNLOADING_COMPLETED = 'completed';
/**
 * @var string Unloading со статусом "Отменена"
 */
export const UNLOADING_CANCELED = 'canceled';
/**
 * @var string Unloading со статусом "На разгрузке"
 */
export const UNLOADING_ON_UNLOADING = 'on-unloading';